import React, { useState } from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Textarea,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { handleToggleContractors } from "actions/actions";
import { toast } from "react-toastify";
const BlockToggle = ({ id, refetch,name }) => {
  const [reason, setReason] = useState("");

  const handleBlock = async () => {
    if (!reason) {
      toast.error("الرجاء كتابة سبب الإلغاء");
      return;
    }

    const res = await handleToggleContractors(id, "deactivate", reason);
    if (res.error) {
      toast.error(res.error);
    } else {
      toast.success(res.success);
      refetch();
    }
  };
  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button
          variant="outline"
          className=" rounded-full bg-red-500 px-6 py-1 text-white transition-all hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
          size="sm"
        >
          إلغاء التفعيل
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            إلغاء تفعيل المقاول <span className="underline ms-1 capitalize">({name})</span>
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <label className="mb-2 block text-base" htmlFor="reason">
            سبب الإلغاء
          </label>
          <Textarea
            className="h-32 w-full resize-none border p-2"
            placeholder="الرجاء كتابة سبب الإلغاء"
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogBody>
        <DialogFooter>
          <Button onClick={handleBlock} variant="outline">
            <span>تأكيد</span>
          </Button>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default BlockToggle;
